import { EvergreenPage } from '../components/seo/EvergreenPage'
import { SSL_DOMAIN_MONITORING_SECTIONS } from '../content/seo/sslDomainMonitoring'
import { articleJsonLd } from '../seo/structuredData'
import { PAGE_META } from '../seo/pageMeta'

const meta = PAGE_META['/ssl-domain-monitoring']

export function SslDomainMonitoringPage() {
  return (
    <EvergreenPage
      path="/ssl-domain-monitoring"
      title="SSL and domain expiry monitoring"
      lead="Get alerts before SSL certificates or domain registrations expire—with daily checks and Slack or email escalation on every plan."
      sections={SSL_DOMAIN_MONITORING_SECTIONS}
      jsonLd={articleJsonLd({
        title: meta.title,
        description: meta.description,
        path: '/ssl-domain-monitoring',
      })}
    />
  )
}
